/* Sélecteur de format en roulette (BOBW)
 * Pilote les radios Dawn cachés : l'animation se joue d'abord, puis la variante
 * est sélectionnée (événement "change" natif), donc Dawn met à jour prix, stock et bouton.
 */
(() => {
  if (customElements.get('format-roulette')) return;

  // Profil du tambour (même perspective que la bannière « Libre »)
  // position relative -> décalage vertical (en hauteurs de ligne) et écrasement vertical
  const KP = [-2.7, -2, -1, 0, 1, 2, 2.7];
  const KY = [-1.73, -1.49, -0.91, 0, 0.91, 1.49, 1.73];
  const KS = [0, 0.27, 0.53, 1, 0.53, 0.27, 0];
  const VISIBLE = 2.69;

  // Interpolation monotone (Fritsch–Carlson) pour un mouvement fluide
  function pchip(xs, ys) {
    const n = xs.length;
    const h = [], d = [], m = new Array(n);
    for (let i = 0; i < n - 1; i++) {
      h[i] = xs[i + 1] - xs[i];
      d[i] = (ys[i + 1] - ys[i]) / h[i];
    }
    m[0] = d[0];
    m[n - 1] = d[n - 2];
    for (let i = 1; i < n - 1; i++) {
      if (d[i - 1] * d[i] <= 0) m[i] = 0;
      else {
        const w1 = 2 * h[i] + h[i - 1], w2 = h[i] + 2 * h[i - 1];
        m[i] = (w1 + w2) / (w1 / d[i - 1] + w2 / d[i]);
      }
    }
    return (x) => {
      if (x <= xs[0]) return ys[0];
      if (x >= xs[n - 1]) return ys[n - 1];
      let i = 0;
      while (x > xs[i + 1]) i++;
      const t = (x - xs[i]) / h[i], t2 = t * t, t3 = t2 * t;
      return (2 * t3 - 3 * t2 + 1) * ys[i] + (t3 - 2 * t2 + t) * h[i] * m[i] +
        (-2 * t3 + 3 * t2) * ys[i + 1] + (t3 - t2) * h[i] * m[i + 1];
    };
  }
  const yAt = pchip(KP, KY);
  const sAt = pchip(KP, KS);

  const mod = (a, n) => ((a % n) + n) % n;
  const easeOutBack = (t, s = 1.2) => { t -= 1; return t * t * ((s + 1) * t + s) + 1; };
  // départ qui accélère, puis décélération avec léger rebond (comme la bannière)
  const spinEase = (t) => {
    const u = t < 0.2 ? 2.5 * t * t : t - 0.1;
    return easeOutBack(u / 0.9, 1.2);
  };
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class FormatRoulette extends HTMLElement {
    connectedCallback() {
      this.radios = Array.from(this.querySelectorAll('.format-roulette__inputs input[type="radio"]'));
      this.n = this.radios.length;
      this.windowEl = this.querySelector('.format-roulette__window');
      this.track = this.querySelector('.format-roulette__track');
      this.status = this.querySelector('.format-roulette__status');
      if (this.n < 2 || !this.windowEl) return;

      // Duplique les formats pour remplir le tambour
      const base = Array.from(this.track.querySelectorAll('.format-roulette__item'));
      const copies = Math.ceil(6 / this.n);
      const nodes = [];
      for (let c = 0; c < copies; c++) {
        base.forEach((el, i) => {
          const node = c === 0 ? el : el.cloneNode(true);
          if (c > 0) this.track.appendChild(node);
          node.classList.remove('is-selected');
          nodes.push({ node, i });
        });
      }
      // calque « pastille » : copie du tambour en couleur inversée
      this.lens = this.querySelector('.format-roulette__lens');
      const lensTrack = this.track.cloneNode(true);
      this.lens.appendChild(lensTrack);
      const twins = Array.from(lensTrack.querySelectorAll('.format-roulette__item'));
      this.slots = nodes.map(({ node, i }, j) => ({
        el: node,
        twin: twins[j],
        text: node.querySelector('.format-roulette__text'),
        twinText: twins[j].querySelector('.format-roulette__text'),
        index: i,
      }));
      this.m = this.slots.length;

      const checked = this.radios.findIndex((r) => r.checked);
      this.pos = checked >= 0 ? checked : 0;
      this.busy = false;

      this.measure();
      this.render(0);
      this.classList.add('is-ready');

      this.onArrow = (e) => {
        const btn = e.target.closest('[data-step]');
        if (!btn) return;
        const step = Number(btn.dataset.step);
        this.spinTo(mod(this.currentIndex() + step, this.n), step);
      };
      this.querySelector('.format-roulette__controls').addEventListener('click', this.onArrow);

      this.bindDrag();

      this.ro = new ResizeObserver(() => { this.measure(); this.render(0); });
      this.ro.observe(this.windowEl);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      this.ro?.disconnect();
    }

    currentIndex() {
      return mod(Math.round(this.pos), this.n);
    }

    measure() {
      const item = this.slots[0].el;
      const cs = getComputedStyle(item);
      const fs = parseFloat(cs.fontSize) || 14;
      const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      this.lineH = item.offsetHeight || fs * 1.25;
      // écart entre lignes : les voisins doivent passer juste au-dessus / au-dessous de la pastille
      const pill = fs + 2 * rem;
      this.spread = Math.max(1, (pill / 2 + this.lineH * 0.53 * 0.4 + 2) / (0.91 * this.lineH));

      // largeur : celle du format le plus long + marges de la pastille
      let widest = 0;
      this.slots.forEach((s) => {
        s.text.style.transform = s.twinText.style.transform = '';
        widest = Math.max(widest, s.text.getBoundingClientRect().width);
      });
      this.style.setProperty('--fr-width', `${Math.ceil(widest + 5.6 * rem)}px`);

      const avail = this.windowEl.clientWidth - 3.2 * rem;
      this.slots.forEach((s) => {
        const w = s.text.getBoundingClientRect().width;
        const fit = w > avail && w > 0 ? avail / w : 1;
        const t = fit < 1 ? `scaleX(${fit.toFixed(3)})` : '';
        s.text.style.transform = s.twinText.style.transform = t;
      });
    }

    render(speed) {
      const H = this.lineH;
      for (let j = 0; j < this.m; j++) {
        const s = this.slots[j];
        const d = mod(j - this.pos + this.m / 2, this.m) - this.m / 2;
        if (Math.abs(d) >= VISIBLE) {
          s.el.style.visibility = s.twin.style.visibility = 'hidden';
          continue;
        }
        const sc = Math.max(sAt(d), 0.001);
        const tf = `translateY(${(yAt(d) * this.spread * H).toFixed(2)}px) scaleY(${sc.toFixed(4)})`;
        s.el.style.visibility = s.twin.style.visibility = 'visible';
        s.el.style.transform = s.twin.style.transform = tf;
      }
      // flou de mouvement vertical, proportionnel à la vitesse
      const b = Math.min(Math.abs(speed) * H * 0.8, H * 0.3);
      if (b > 0.4) {
        this.style.setProperty('--fr-blur', `${b.toFixed(1)}px`);
        this.classList.add('is-spinning');
      } else {
        this.classList.remove('is-spinning');
      }
    }

    animateTo(endPos, duration, ease, done) {
      cancelAnimationFrame(this.raf);
      const startPos = this.pos;
      const delta = endPos - startPos;
      const t0 = performance.now();
      let last = startPos;
      this.busy = true;
      const tick = (now) => {
        const t = Math.min((now - t0) / duration, 1);
        this.pos = startPos + delta * ease(t);
        this.render(this.pos - last);
        last = this.pos;
        if (t < 1) {
          this.raf = requestAnimationFrame(tick);
        } else {
          this.pos = mod(Math.round(endPos), this.m);
          this.render(0);
          this.busy = false;
          done?.();
        }
      };
      this.raf = requestAnimationFrame(tick);
    }

    // dir : +1 = le format suivant monte au centre, -1 = le précédent descend
    spinTo(target, dir) {
      if (this.busy) return;
      const cur = this.currentIndex();
      const steps = dir > 0 ? mod(target - cur, this.n) : mod(cur - target, this.n);
      const calm = reduceMotion();
      const total = steps + (calm ? 0 : this.n); // un tour complet en plus pour l'effet machine à sous
      if (total === 0) return;
      const duration = calm ? 220 : Math.min(650 + total * 80, 1500);
      this.animateTo(Math.round(this.pos) + dir * total, duration, calm ? (t) => t : spinEase, () => this.select(target));
    }

    select(index) {
      const radio = this.radios[index];
      if (!radio) return;
      if (this.status) this.status.textContent = radio.value;
      if (radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    bindDrag() {
      const win = this.windowEl;
      let startY = 0, startPos = 0, moved = 0, lastY = 0, lastT = 0, vel = 0, active = false;

      win.addEventListener('pointerdown', (e) => {
        if (this.busy || (e.pointerType === 'mouse' && e.button !== 0)) return;
        active = true;
        moved = 0;
        vel = 0;
        startY = lastY = e.clientY;
        startPos = this.pos;
        lastT = performance.now();
        win.setPointerCapture(e.pointerId);
      });

      win.addEventListener('pointermove', (e) => {
        if (!active) return;
        const dy = e.clientY - startY;
        moved = Math.max(moved, Math.abs(dy));
        if (moved < 6) return;
        win.classList.add('is-dragging');
        const now = performance.now();
        const step = this.lineH * this.spread * 0.91;
        vel = -((e.clientY - lastY) / step) / Math.max(now - lastT, 1); // positions / ms
        lastY = e.clientY;
        lastT = now;
        this.pos = startPos - dy / step;
        this.render(0);
      });

      const end = (e) => {
        if (!active) return;
        active = false;
        win.classList.remove('is-dragging');

        if (moved < 6) {
          // simple clic : on vise le format touché
          const hit = document.elementFromPoint(e.clientX, e.clientY)?.closest('.format-roulette__item');
          const slot = this.slots.find((s) => s.el === hit || s.twin === hit);
          if (!slot) return;
          const j = this.slots.indexOf(slot);
          const d = Math.round(mod(j - this.pos + this.m / 2, this.m) - this.m / 2);
          if (d !== 0) this.spinTo(slot.index, Math.sign(d));
          return;
        }

        // lancer au doigt : on laisse filer puis on cale avec rebond
        const projected = this.pos + vel * 220;
        const endPos = Math.round(projected);
        const dist = Math.abs(endPos - this.pos);
        const calm = reduceMotion();
        const duration = calm ? 200 : Math.min(320 + dist * 90, 1200);
        this.animateTo(endPos, duration, calm ? (t) => t : (t) => easeOutBack(t, 1.3), () =>
          this.select(mod(endPos, this.m) % this.n)
        );
      };
      win.addEventListener('pointerup', end);
      win.addEventListener('pointercancel', end);
    }
  }

  customElements.define('format-roulette', FormatRoulette);
})();
